import styled from '@emotion/styled';
import { IconButton } from '@mui/material';

export const IconButtonStyled = styled(IconButton)`
  cursor: pointer;
`;
